import Vue from 'vue';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/ar';
import 'dayjs/locale/zh';
import 'dayjs/locale/ko';
import 'dayjs/locale/ja';
import 'dayjs/locale/pt';
import 'dayjs/locale/de';

Vue.prototype.$dayjs = dayjs.extend(relativeTime);
